require('./bootstrap');
// require('./jquery.easing');
require('./sb-admin-2');

require('./jquery.mask');
require('./jquery.maskMoney.min');
require('./jquery.printPage');
require('./select2');
require("flatpickr");
require('flatpickr/dist/l10n/pt');

var token = $('meta[name="api"]').attr('content');
var csrf = $('meta[name="csrf-token"]').attr('content');

readURL = function(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
            $('#thumb').attr('src', e.target.result);
        };
        reader.readAsDataURL(input.files[0]);
    }
};

// Deletar Registros
$('#ConfirmDelete').on('show.bs.modal', function(e) {
    $nome = $(e.relatedTarget).parent().parent().find('td').eq(1).text();
    var id = $(e.relatedTarget).attr('data-id');
    var message = "Realmente deseja Apagar o Registro de <b>"+ $nome+"</b> cod# "+ id +" ?";
    var act = $(e.relatedTarget).attr('href');
    var form = '<form name="form" method="post" action="'+act+'"> ' +
        '<input type="hidden" name="_method" value="DELETE">'
        + '<input name="_token" type="hidden" value="'+csrf+'">'
        + '<input type="submit" value="Confirma" class="btn btn-danger btn-sm active">'
        + '</form>';
    $(this).find('.modal-body p').html(message);
    $(this).find('.modal-footer').html(form);
});

// Deletar Registros
$('#ConfirmDeleteTit').on('show.bs.modal', function(e) {
    $nome = $(e.relatedTarget).parent().parent().find('td').eq(1).text();
    var id = $(e.relatedTarget).attr('data-id');
    var message = "Realmente deseja Apagar o Registro de <b>"+ $nome+"</b> cod# "+ id +" " +
        "e todos os seus pagamentos ? isso ira impactar o movimento de caixa";
    var act = $(e.relatedTarget).attr('href');
    var form = '<form name="form" method="post" action="'+act+'"> ' +
        '<input type="hidden" name="_method" value="DELETE">'
        + '<input name="_token" type="hidden" value="'+csrf+'">'
        + '<input type="submit" value="Confirma" class="btn btn-danger btn-sm active">'
        + '</form>';
    $(this).find('.modal-body p').html(message);
    $(this).find('.modal-footer').html(form);
});

// Disable button on submit
$(document).ready(function () {
    $('form').submit(function() {
        var el = $(this);
        el.find("button[type='submit'],input[type='submit']").prop('disabled',true);
        $('select').removeAttr('disabled');
        setTimeout(function(){el.prop('disabled', false); }, 7000);
    });
});

// modal
$("body").on('click','.loadModal,.bigModal',function(ev) {
    ev.preventDefault();
    if($(this).hasClass("bigModal")){
        $("#myModal .modal-dialog").addClass('modal-lg');
    }
    var target = $(this).attr("href");
    $("#myModal .modal-content").load(target, function() {

        // $('.tel').mask(maskBehavior, options);
        $('#myModal').modal({
            backdrop: 'static',
            keyboard: false
        });
        $('.selectizeModal').select2({
            placeholder: "Selecione uma opção",
            width : '100%',
            selectOnClose: true
        });

        $(".dataModal").flatpickr({
            "locale": "pt",
            'dateFormat': "d/m/Y",
            'allowInput' : true,
            'minDate': '01/01/1900',
            'maxDate': '31/12/2100',
            onReady: function(selectedDates, dateStr, instance) {
                if (!instance.calendarContainer) return;
                instance.calendarContainer.addEventListener('keydown', function(e) {
                    if (!e.target || !e.target.classList) return;
                    e.stopPropagation();
                });
            },
            onChange: function(selectedDates, dateStr, instance) {
                if (selectedDates.length > 0) {
                    var year = selectedDates[0].getFullYear();
                    if (year < 1900 || year > 2100) {
                        instance.clear();
                        alert('Ano deve estar entre 1900 e 2100');
                    }
                }
            }
        });
        $('.dataHora').mask('99/99/9999 99:99', {
    placeholder: "dd/mm/yyyy hh:mm",
    clearIfNotMatch: true,
    onComplete: function(value) {
        var parts = value.split(' ')[0].split('/');
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);
        
        // Função para definir data/hora de hoje
        var setDataHoraHoje = function(campo) {
            var hoje = new Date();
            var dia = String(hoje.getDate()).padStart(2, '0');
            var mes = String(hoje.getMonth() + 1).padStart(2, '0');
            var ano = hoje.getFullYear();
            var hora = String(hoje.getHours()).padStart(2, '0');
            var min = String(hoje.getMinutes()).padStart(2, '0');
            campo.val(dia + '/' + mes + '/' + ano + ' ' + hora + ':' + min).focus();
        };
        
        if (year < 1900 || year > 2100 || day < 1 || day > 31 || month < 1 || month > 12) {
            setDataHoraHoje($(this));
            alert('Data inválida. Definindo data atual.');
        } else {
            // Validar dias por mês
            var daysInMonth = new Date(year, month, 0).getDate();
            if (day > daysInMonth) {
                setDataHoraHoje($(this));
                alert('Data inválida. Definindo data atual.');
            }
        }
    }
});
        $('.hora').mask('99:99');
        $(".money").maskMoney({prefix:'R$ ', allowNegative: true, thousands:'.', decimal:',', affixesStay: false});
    });
});

$('body').on('hidden.bs.modal', '.modal', function () {
    $(this).removeData('bs.modal');
});

$('body').on('shown.bs.modal', '.modal', function () {
    $('#focusModal').focus();
});

$('body').on('click','.printAcerto,.printPage',function (e) {
    e.preventDefault();
    $(this).printPage({
        message:"Seu documento está sendo impresso",
    });
    $(this).click();
});

var maskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    options = {onKeyPress: function(val, e, field, options) {
            field.mask(maskBehavior.apply({}, arguments), options);
        }
    };

$('.tel').mask(maskBehavior, options);
$(".cep").mask("99.999-999");
$(".cnpj").mask("99.999.999/9999-99");
$(".cpf").mask("999.999.999-99");
$('.hora').mask('99:99');

$('.dataModal').mask('99/99/9999', {
    placeholder: "dd/mm/yyyy",
    clearIfNotMatch: true
});
$('.anoModelo').mask('9999/9999');
$('.dataHora').mask('99/99/9999 99:99', {
    placeholder: "dd/mm/yyyy hh:mm",
    clearIfNotMatch: true,
    onComplete: function(value) {
        var parts = value.split(' ')[0].split('/');
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);
        
        // Função para definir data/hora de hoje
        var setDataHoraHoje = function(campo) {
            var hoje = new Date();
            var dia = String(hoje.getDate()).padStart(2, '0');
            var mes = String(hoje.getMonth() + 1).padStart(2, '0');
            var ano = hoje.getFullYear();
            var hora = String(hoje.getHours()).padStart(2, '0');
            var min = String(hoje.getMinutes()).padStart(2, '0');
            campo.val(dia + '/' + mes + '/' + ano + ' ' + hora + ':' + min).focus();
        };
        
        if (year < 1900 || year > 2100 || day < 1 || day > 31 || month < 1 || month > 12) {
            setDataHoraHoje($(this));
            alert('Data inválida. Definindo data atual.');
        } else {
            // Validar dias por mês
            var daysInMonth = new Date(year, month, 0).getDate();
            if (day > daysInMonth) {
                setDataHoraHoje($(this));
                alert('Data inválida. Definindo data atual.');
            }
        }
    }
});
$('.monetary').maskMoney();
$(".money").maskMoney({prefix:'R$ ', allowNegative: true, thousands:'.', decimal:',', affixesStay: false});

$('body').on('focus', '.data', function(){
    var field = $(this);
    
    field.mask("99/99/9999", {
        placeholder: "dd/mm/yyyy",
        clearIfNotMatch: false, // Não limpar automaticamente
        onComplete: function(value) {
            var parts = value.split('/');
            var day = parseInt(parts[0], 10);
            var month = parseInt(parts[1], 10);
            var year = parseInt(parts[2], 10);
            
            // Função para definir data de hoje
            var setDataHoje = function() {
                var hoje = new Date();
                var dia = String(hoje.getDate()).padStart(2, '0');
                var mes = String(hoje.getMonth() + 1).padStart(2, '0');
                var ano = hoje.getFullYear();
                field.val(dia + '/' + mes + '/' + ano);
                field.trigger('input'); // Para componentes que escutam mudanças
            };
            
            // Validar dia (1-31)
            if (day < 1 || day > 31) {
                setDataHoje();
                return;
            }
            
            // Validar mês (1-12)
            if (month < 1 || month > 12) {
                setDataHoje();
                return;
            }
            
            // Validar ano (1900-2100)
            if (year < 1900 || year > 2100) {
                setDataHoje();
                return;
            }
            
            // Validar dias por mês
            var daysInMonth = new Date(year, month, 0).getDate();
            if (day > daysInMonth) {
                setDataHoje();
                return;
            }
        }
    });
});

// Adicionar validação ao sair do campo (blur)
$('body').on('blur', '.data', function(){
    var field = $(this);
    var value = field.val();
    
    if (value && value.length === 10) { // Se tiver algo digitado no formato completo
        var parts = value.split('/');
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);
        
        // Função para definir data de hoje
        var setDataHoje = function() {
            var hoje = new Date();
            var dia = String(hoje.getDate()).padStart(2, '0');
            var mes = String(hoje.getMonth() + 1).padStart(2, '0');
            var ano = hoje.getFullYear();
            field.val(dia + '/' + mes + '/' + ano);
            field.trigger('input');
        };
        
        // Validar se é uma data inválida
        if (year < 1900 || year > 2100 || day < 1 || day > 31 || month < 1 || month > 12) {
            setDataHoje();
        } else {
            // Validar dias por mês
            var daysInMonth = new Date(year, month, 0).getDate();
            if (day > daysInMonth) {
                setDataHoje();
            }
        }
    }
});

$('body').on('focus', '.money', function(){
    $(this).maskMoney({prefix:'R$ ', allowNegative: true, thousands:'.', decimal:',', affixesStay: false});
});

var CpfCnpjMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length <= 11 ? '000.000.000-009' : '00.000.000/0000-00';
    },
    cpfCnpjpOptions = {
        onKeyPress: function(val, e, field, options) {
            field.mask(CpfCnpjMaskBehavior.apply({}, arguments), options);
        }
    };

$('.cpfcnpj').mask(CpfCnpjMaskBehavior, cpfCnpjpOptions);

$(".data").flatpickr({
    "locale": "pt",
    'allowInput' : true,
    'dateFormat': "d/m/Y",
    'minDate': '01/01/1900',
    'maxDate': '31/12/2100',
    onReady: function(selectedDates, dateStr, instance) {
        if (!instance.calendarContainer) return;
        instance.calendarContainer.addEventListener('keydown', function(e) {
            if (!e.target || !e.target.classList) return;
            e.stopPropagation();
        });
    },
    onChange: function(selectedDates, dateStr, instance) {
        if (selectedDates.length > 0) {
            var year = selectedDates[0].getFullYear();
            if (year < 1900 || year > 2100) {
                instance.clear();
                alert('Ano deve estar entre 1900 e 2100');
            }
        }
    }
});

//Busca cep
$(document).on('blur','.cep',function() {
    var cep = $(this).val().replace(/\D/g, '');
    if (cep != "") {
        var validacep = /^[0-9]{8}$/;
        if(validacep.test(cep)) {
            //Preenche os campos com "..." enquanto consulta webservice.
            $(".rua").val("...");
            $(".bairro").val("...");
            $(".cidade").val("...");
            $(".uf").val("...");

            $.getJSON("//viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {
                if (!("erro" in dados)) {
                    //Atualiza os campos com os valores da consulta.
                    $(".rua").val(dados.logradouro);
                    $(".bairro").val(dados.bairro);
                    $(".cidade").val(dados.localidade);
                    var newOption = new Option(dados.localidade+' - '+dados.uf, dados.ibge, true, true);
                    $('#city').append(newOption).trigger('change');
                }
                else {
                    $('.rua').focus();
                    alert("CEP não encontrado.");
                }
            });
        }
        else {
            $('.rua').focus();
            alert("Formato de CEP inválido.");
        }
    }
});

$("#checkAll").click(function(){
    $('input:checkbox').not(this).prop('checked', this.checked);
});

$(document).ready(function () {
    function matchCustom(params, data) {

        // If there are no search terms, return all of the data
        if ($.trim(params.term) === '') {
            return data;
        }
        // Do not display the item if there is no 'text' property
        if (typeof data.text === 'undefined') {
            return null;
        }

        const terms = params.term.toUpperCase().split(' ');
        var text = data.text.toUpperCase();
        var ok = true;
        var res = terms.every(term => {
            if (text.indexOf(term) > -1 && ok == true) {
                return true;
            } else{
                ok = false;
                return false;
            }
        });

        if(res){
            return $.extend({}, data, true)
        }

        return null;

    }

    $('.selectize').select2({
        placeholder: "Selecione uma opção",
        selectOnClose: true,
        matcher: matchCustom,
        //width : '350px',
    });

    $('#flash-overlay-modal').modal();
});

$('#city').select2(optionsSelect2('cidades'));

function optionsSelect2(type)
{
    return {
        minimumInputLength: 2,
        placeholder: "Buscar",
        ajax: {
            url: '/api/'+type,
            dataType: 'json',
            type: "GET",
            beforeSend: function (xhr) {
                xhr.setRequestHeader ('Authorization', 'Bearer '+token);
            },
            quietMillis: 50,
            data: function (params) {
                var queryParameters = {
                    q: params.term
                };
                return queryParameters;
            },
        },
    }
}

$(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
    $(this).closest(".select2-container").siblings('select:enabled').select2('open');
});

$(document).on('select2:open', () => {
    document.querySelector('.select2-search__field').focus();
});

// steal focus during close - only capture once and stop propogation
$('select.select2').on('select2:closing', function (e) {
    $(e.target).data("select2").$selection.one('focus focusin', function (e) {
        e.stopPropagation();
    });
});

function dinheiro(v)
{
    return v.toLocaleString( 'pt-Br',{style: 'currency', currency: 'BRL'});
}

$('body').on('click','.cloneTr',function(e){
    e.preventDefault();
    var table = $(this).parent().parent().parent();
    var tr = table.find('tr').first().clone();
    tr.appendTo(table).show('slow');
    table.find('tr').last().children("td:nth-child(1)").find('select').prop('required',true).select2({
        width : '100%',
        selectOnClose: true
    });
    table.find('tr').last().find('select.addSelect').select2({
        width : '100%',
        selectOnClose: true
    });
    $(".dataModal").flatpickr({
        "locale": "pt",
        'dateFormat': "d/m/Y",
        'minDate': '01/01/1900',
        'maxDate': '31/12/2100',
        onReady: function(selectedDates, dateStr, instance) {
            if (!instance.calendarContainer) return;
            instance.calendarContainer.addEventListener('keydown', function(e) {
                if (!e.target || !e.target.classList) return;
                e.stopPropagation();
            });
        },
        onChange: function(selectedDates, dateStr, instance) {
            if (selectedDates.length > 0) {
                var year = selectedDates[0].getFullYear();
                if (year < 1900 || year > 2100) {
                    instance.clear();
                    alert('Ano deve estar entre 1900 e 2100');
                }
            }
        }
    });
    $(".money").maskMoney({prefix:'R$ ', allowNegative: true, thousands:'.', decimal:',', affixesStay: false});
    table.find('tr').last().attr('class','mostrar');
});

//remove Tr
$('body').on('click','.trRemove',function(e){
    e.preventDefault();
    $tr = $(this).parent().parent();
    $tr.fadeOut(400, function () {
        $tr.remove();
    });
});

$('body').on('click','.sendPermit',function(e){
    $element = $(this);
    $element.hide();
    var td = $element.parent();
    td.append('<i class="fa fa-spinner fa-pulse"></i>');
    var value = $(this).data('value');
    var grupo = $(this).data('group');
    var action = $(this).data('action');
    var url = '/permissions/liberar/'+action+'/'+grupo;
    if(value == 0){
        var info = '<i class="fa fa-times btn btn-danger btn-xs sendPermit" data-group="'+grupo+'" data-action="'+action+'" data-value="1"></i>';
    } else{
        var info = '<i class="fa fa-check btn btn-success btn-xs sendPermit" data-group="'+grupo+'" data-action="'+action+'" data-value="0"></i>';
    }
    $.ajax({
        type: "GET",
        url: url,
        async: true,
        cache: false,
        success: function (data, status) {
            $('.fa-spinner').remove();
            if (data == "erro") {
                $element.show();
                alert('Ocorreu um erro ao processar a requisição, tente novamente')
            } else {
                td.html(info);
            }
        }
    });
});

$(document).ready(function () {
    $('#flash-overlay-modal').modal();
    //$('div.alert').not('.alert-important').delay(5000).fadeOut(350);
});

$(function(){
    $("ul.checktree").checktree();
});
(function($){
    $.fn.checktree = function(){
        $('body').on('click',':checkbox', function (event){
            event.stopPropagation();
            var clk_checkbox = $(this),
                chk_state = clk_checkbox.is(':checked'),
                parent_li = clk_checkbox.closest('li'),
                parent_uls = parent_li.parents('ul');
            parent_li.find(':checkbox').prop('checked', chk_state);
            parent_uls.each(function(){
                parent_ul = $(this);
                parent_state = (parent_ul.find(':checkbox').length == parent_ul.find(':checked').length);
                parent_ul.siblings(':checkbox').prop('checked', parent_state);
            });
        });
    };
}(jQuery));

$('.changeTurno').on('change', function(){
    var val = $(this).val();
    var v = $('#veicForm').data('cod');
    var url = '/veiculos/turno-horario/'+val+'/'+v;
    $('#loadTurno').load(url);
});

$('.validaCPF').on('blur', function () {
    var v = $(this).val();
    var cpf = v.replace(/\D/g, "");
    if(!TestaCPF(cpf)){
        alert('CPF invalido, necessário informar um CPF Valido para efetuar o cadastro.');
    }
});

$('.checaCPF').on('blur', function () {
    var v = $(this).val();
    var cpf = v.replace(/\D/g, "");
    if(TestaCPF(cpf)){
        $("#loading").show();
        var url = '/api/aluno-cpf/'+cpf;
        $.ajax({
            type: "GET",
            url: url,
            async: true,
            cache: false,
            beforeSend: function (xhr) {
                xhr.setRequestHeader ('Authorization', 'Bearer '+token);
            },
            success: function (data, status) {
                console.log(data);
                if(data[1]){
                    $('#myModalCPF').modal('show');
                    $('#linkCPF').attr('href', '/alunos/'+data[0]+'/edit');
                    $("#loading").hide();
                } else {
                    preencherDadosAluno(data[0])
                    $("#loading").hide();
                }
            }
        });
    } else{
        $('#alunoNome').focus();
        alert('CPF invalido, necessário informar um CPF Valido para efetuar o cadastro.');
    }
});

function preencherDadosAluno(dado)
{
    $('#alunoNome').val(dado.nome);
    $('#rg').val(dado.rg);
    $('#rg_orgao').val(dado.rg_orgao);
    $('#rg_uf').val(dado.rg_uf);
    $('#data_nascimento').val(dado.data_nascimento);
    $('#sexo').val(dado.sexo);
    $('#mae').val(dado.mae);
    $('#pai').val(dado.pai);
    $('#celular1').val(dado.celular1);
    $('#cep').val(dado.cep);
    $('#cep').blur();
    $('#complemento').val(dado.complemento);
    $('#telefone').blur();
}

function TestaCPF(strCPF) {
    var Soma;
    var Resto;
    Soma = 0;
    if (strCPF == "00000000000") return false;
    else if (strCPF == "11111111111") return false;
    else if (strCPF == "22222222222") return false;
    else if (strCPF == "33333333333") return false;
    else if (strCPF == "44444444444") return false;
    else if (strCPF == "55555555555") return false;
    else if (strCPF == "66666666666") return false;
    else if (strCPF == "77777777777") return false;
    else if (strCPF == "88888888888") return false;
    else if (strCPF == "99999999999") return false;

    for (i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;

    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
    return true;
}

const observer = new MutationObserver(function() {
    if ($('.alert').length > 0) {
        let target = $(".navbar-nav");
        smoothScroll(target, 500);
    }
});

// function smoothScroll(target, duration) {
//     let targetPosition = target.offset().top;
//     let startPosition = $(window).scrollTop();
//     let distance = targetPosition - startPosition;
//     let startTime = null;
//
//     function animation(currentTime) {
//         if (startTime === null) startTime = currentTime;
//         let timeElapsed = currentTime - startTime;
//         let run = ease(timeElapsed, startPosition, distance, duration);
//
//         $(window).scrollTop(run);
//
//         if(timeElapsed < duration) window.requestAnimationFrame(animation);
//     }
//
//     // you can change 'ease' to other easing functions
//     function ease(t, b, c, d) {
//         t /= d / 2;
//         if (t < 1) return c / 2 * t * t + b;
//         t--;
//         return -c / 2 * (t * (t - 2) - 1) + b;
//     }
//
//     window.requestAnimationFrame(animation);
// }
//
// observer.observe(document.body, { childList: true, subtree: true });

$('.tenant-pagar').on('click', function() {
    fetch('/pagar')
        .then(response => response.json())
        .then(data => {
            window.open(data.url, '_blank');
        });
});
